import React from 'react';
import { useAppSelector } from '~redux/hooks';
import GoldInventoryExportPDF from './ExportPDF';

const InventoryReceivedPDF = () => {
    const inventoryReceivedListing = useAppSelector((state) => state.gold.goldInventoryReport.inventoryReceived.data);

    return (
        <div>
            <GoldInventoryExportPDF
                inventoryReceivedListing={inventoryReceivedListing}
            />
        </div>
    );
};

export default InventoryReceivedPDF;
